function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { businessGlossaryMixin } from '@/mixins/business_glossary';
import { userMixin } from '@/mixins/user';
import businessTermService from '@/apps/data-platform/services/master_data/business_term_service';
import BaseLoading from '@/components/BaseLoading';
import tasks from '@/js/tasks';
import { mapState } from 'vuex';
import { TYPE_CHANGE_METADA, envConfig, GA_EVENTS } from '@/js/constants';
export default {
  name: 'TabMetadataBusinessTermsComponent',
  mixins: [businessGlossaryMixin, userMixin],
  components: {
    BaseLoading: BaseLoading
  },
  props: {
    columnFields: {
      type: Array,
      required: true
    },
    relativeResourceName: {
      type: String,
      required: true
    },
    domainTable: {
      type: String,
      required: true
    },
    validUserAccess: {
      type: Boolean,
      required: true
    },
    isChangeRequest: {
      type: String,
      required: false,
      default: TYPE_CHANGE_METADA.UPDATE
    },
    dataOperator: {
      type: String,
      required: false,
      default: ''
    },
    source: {
      type: String,
      required: false,
      default: 'bigquery'
    }
  },
  data: function data() {
    return {
      UNDEFINED: 'Undefined',
      leyenda: this.traductor('my_tasks.modals.leyenda_bterm'),
      register: {},
      selectbusinessTerm: [],
      type: '',
      kdomain: '',
      ksubdomain: '',
      kbusiness_term: '',
      business_term: '',
      columnFieldsLabels: [
      //{ key: '↕', variant: 'return-sort', class: 'w-5' },
      {
        text: 'Column',
        value: 'column',
        sortable: true,
        class: 'w-20'
      }, {
        text: 'Data Element Name',
        value: 'fields.data_element_name.stringValue',
        sortable: true,
        class: 'w-20'
      }, {
        text: 'Business Definition',
        value: 'fields.business_definition.stringValue',
        sortable: true,
        class: 'w-20'
      }, {
        text: 'Business Term',
        value: 'fields.business_term.displayName',
        class: 'w-20'
      }, {
        text: '',
        value: 'actions',
        class: 'w-5'
      }, {
        thStyle: {
          width: '80px !important'
        },
        text: '',
        value: 'navigator',
        class: 'w-10'
      }],
      input1: '',
      input1state: null,
      input2: '',
      input2state: null,
      options: [{
        text: '- Choose 1 -',
        value: ''
      }, 'Red', 'Green', 'Blue'],
      input1Return: '',
      input2Return: '',
      popoverShow: false,
      newColumnFields: [],
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      filter: '',
      inputSearch: '',
      isLoading: false,
      showShared: false,
      perPage: envConfig.TABLE_TAGS_LIMIT,
      currentPage: 1,
      totalRows: 1,
      filterOn: [],
      bterms: 1,
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    headers: function headers() {
      return [{
        text: this.traductor('my_tasks.modals.column'),
        value: 'column',
        sortable: true,
        class: 'w-20'
      }, {
        text: this.traductor('my_tasks.modals.data_element'),
        value: 'fields.data_element_name.stringValue',
        sortable: true,
        class: 'w-20'
      }, {
        text: this.traductor('my_tasks.modals.bdefinition'),
        value: 'fields.business_definition.stringValue',
        sortable: true,
        class: 'w-20'
      }, {
        text: this.traductor('my_tasks.modals.bterm'),
        value: 'fields.business_term.displayName',
        class: 'w-20'
      }, {
        text: '',
        value: 'actions',
        class: 'w-5'
      }, {
        thStyle: {
          width: '80px !important'
        },
        text: '',
        value: 'navigator',
        class: 'w-10'
      }];
    },
    filterBusinessTerm: function filterBusinessTerm() {
      var _this = this;
      return function (bTerm) {
        var callback = function callback(bterm) {
          return bterm.status === true && bterm.ksubdomain === _this.ksubdomain;
        };
        if (bTerm.fields.business_term.stringValue) {
          callback = function callback(bterm) {
            return bterm.status === true && bterm.ksubdomain === _this.ksubdomain && bterm.kbusiness_term !== bTerm.fields.business_term.stringValue;
          };
        }
        if (_this.showShared === true) {
          callback = function callback(bterm) {
            return bterm.shared === true;
          };
        }
        var selectbusinessTerm = _this.selectbusinessTerm.filter(callback);
        return selectbusinessTerm;
      };
    },
    userBelongToDomain: function userBelongToDomain() {
      return this.userInfo.domain === this.domainTable;
    },
    isCurrentDataOperatorLogged: function isCurrentDataOperatorLogged() {
      return this.dataOperator === window.userInfo.email;
    }
  }),
  created: function created() {
    var _this2 = this;
    this.userInfo = tasks.getUserInfo();
    console.log("aqui source", this.source);
    this.cDomain = this.domainTable;
    var i, iResponse;
    var businessDomain = {
      domain: this.cDomain
    };
    this.isLoading = true;
    this.selectbusinessTerm = [];
    businessTermService.getBusinessTerms(businessDomain).then(function (response) {
      iResponse = response;
    }).then(function () {
      for (i = 0; i < iResponse.data.result.length; i++) {
        _this2.selectbusinessTerm.push({
          value: iResponse.data.result[i].kbusiness_term,
          text: iResponse.data.result[i].business_term,
          kdomain: iResponse.data.result[i].kdomain || _this2.UNDEFINED,
          ksubdomain: iResponse.data.result[i].ksubdomain || _this2.UNDEFINED,
          shared: iResponse.data.result[i].shared || false,
          kbusiness_term: iResponse.data.result[i].kbusiness_term,
          business_term: iResponse.data.result[i].business_term,
          status: iResponse.data.result[i].status
        });
      }
      _this2.isLoading = false;
      _this2.initializeColumns();
    });
  },
  mounted: function mounted() {
    // Set the initial number of items
    this.totalRows = this.columnFields.length;
  },
  watch: {
    columnFields: {
      handler: function handler(newVal) {
        this.initializeColumns();
      },
      deep: true
    }
  },
  methods: {
    initializeColumns: function initializeColumns() {
      var _this3 = this;
      this.newColumnFields = [];
      var _loop = function _loop() {
        _this3.newColumnFields.push({
          name: _this3.columnFields[i].name,
          fields: _this3.columnFields[i].fields,
          column: _this3.columnFields[i].column
        });
        if (!_this3.newColumnFields[i].fields.business_term) {
          _this3.newColumnFields[i].fields.business_term = {
            displayName: 'Business Term',
            stringValue: 'Null'
          };
        }
        var kbterm = _this3.newColumnFields[i].fields.business_term.stringValue;
        var index = _this3.selectbusinessTerm.findIndex(function (bterm) {
          return bterm.kbusiness_term.includes(kbterm);
        });
        if (kbterm !== '.' && kbterm !== 'Null' && kbterm !== 'NULL' && index !== -1 && kbterm) {
          _this3.newColumnFields[i].fields.business_term.displayName = _this3.selectbusinessTerm[index].business_term;
        } else {
          _this3.newColumnFields[i].fields.business_term.displayName = '';
        }
      };
      for (var i = 0; i < this.columnFields.length; i++) {
        _loop();
      }
      this.totalRows = this.newColumnFields.length;
      this.bterms += 1;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onSubmit: function onSubmit(event) {
      var _this4 = this;
      event.preventDefault();
      var i;
      var businessTerm = {
        domain_table: this.domainTable,
        relativeResourceName: this.relativeResourceName,
        data: {},
        source: this.source
      };
      for (i = 0; i < this.newColumnFields.length; i++) {
        if (this.newColumnFields[i].fields.business_term) {
          if (this.newColumnFields[i].fields.business_term.stringValue === '.') {
            businessTerm.data[this.newColumnFields[i].column] = '';
          } else {
            businessTerm.data[this.newColumnFields[i].column] = this.newColumnFields[i].fields.business_term.stringValue;
          }
        }
      }
      return businessTermService.manageTermDataCatalogTable(businessTerm).then(function (response) {
        if (response.code === 200) {
          tasks.toast.success(_this4.translate('success_messages.general'), _this4.translate('titles.success'));
          if (_this4.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.ADD_BTERM_TABLE,
              company_code: _this4.companyCode,
              table: _this4.relativeResourceName,
              hash_email: _this4.stringToHash(userInfo.email),
              module: 'data_platform'
            });
          }
        } else {
          tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('titles.error'));
        }
      });
    },
    onClosedelete: function onClosedelete(index) {
      var popover = 'popover-reacDel-';
      var popover2 = popover.concat(index);
      this.$refs[popover2].doClose();
    },
    onClose: function onClose(index) {
      var ref = this.$refs['popover-reactive-' + index];
      if (!ref) return; // 🔥 evita el crash

      if (Array.isArray(ref)) {
        ref[0].doClose();
      } else {
        ref.doClose();
      }
    },
    onCancel: function onCancel() {
      this.$emit('cancel2', null);
    },
    deleteRecord: function deleteRecord(index) {
      this.onClosedelete(index);
      this.newColumnFields[index].fields.business_term = {};
      this.newColumnFields[index].fields.business_term.stringValue = '.';
      this.newColumnFields[index].fields.business_term.displayName = '';
      //this.$refs.bterms.refresh()
      this.bterms += 1;
    },
    onOk: function onOk(item) {
      var _this5 = this;
      if (!this.input1Return) return;
      this.onClose(this.pagination.limit * (this.pagination.current - 1) + this.newColumnFields.findIndex(function (col) {
        return col.column === item.column;
      }));

      // 🔥 buscar índice REAL (no el de la página)
      var realIndex = this.newColumnFields.findIndex(function (col) {
        return col.column === item.column;
      });
      if (realIndex === -1) return;
      var term = this.selectbusinessTerm.find(function (b) {
        return b.kbusiness_term === _this5.input1Return;
      });
      this.newColumnFields[realIndex].fields.business_term = {
        stringValue: this.input1Return,
        displayName: term ? term.business_term : ''
      };
      this.input1Return = '';

      // forzar refresh tabla
      this.bterms += 1;
    },
    openBusinessTerm: function openBusinessTerm(item) {
      var routeData = this.$router.resolve({
        name: 'BusinessTerm',
        params: {
          domain: this.domainTable,
          id: item.fields.business_term.stringValue
        }
      });
      window.open(routeData.href, '_blank');
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};